var map = {
	"./02_Walter-Schmid_Thumbnail_zugeschnitten.png": 7298,
	"./0618.png": 419,
	"./AFA.png": 8246,
	"./AFA.svg": 6000,
	"./bild_1.png": 2261,
	"./lien_sources.png": 617,
	"./logo-memoriav.svg": 8684,
	"./logo_cinematheque.svg": 3003,
	"./logo_erhfa.png": 582,
	"./logo_eurho.jpg": 8913,
	"./logo_lichtspiel.jpg": 7541,
	"./loterie_romande.jpg": 1289,
	"./persons.png": 5498,
	"./sgg-ssh-logo.png": 4466,
	"./sponsor15.jpg": 1248,
	"./sponsor15.png": 3988
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1868;